const getPatientGender = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient.Gender ? patient.Gender.substr(0, 1) : null;
};

export default getPatientGender;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientGender.js